import { ActionType, getType } from 'typesafe-actions';
import * as actions from './actions';

export interface IFAQState {
  readonly index: number;
  readonly opacity: boolean;
}

export type FAQActions = ActionType<typeof actions>;

const initialState: IFAQState = {
  index: 0,
  opacity: true
};

export default (state = initialState, action: FAQActions): IFAQState => {
  switch (action.type) {
    case getType(actions.changeFAQ): {
      return {
        ...state,
        index: action.payload
      };
    }
    case getType(actions.setOpacity): {
      const newState = {
        ...state,
        opacity: action.payload
      };
      
      return newState;
    }
    default: {
      return state;
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/faq/reducer.ts